<script>
    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    import { getContext, setContext } from 'svelte';
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     bg?: boolean | string | null,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { bg = null, children } = $props();

    const tableBg = $derived(getContext('ly-table-colors')?.value?.next);
    const tableBodyBg = $derived(getContext('ly-table-tbody-colors')?.value?.next);
    const tableBodyRowBg = $derived(getContext('ly-table-tbody-row-colors')?.value?.next);
    const useBg = $derived(bg !== null ? bg : (tableBodyBg ?? tableBodyRowBg ?? tableBg ?? true));

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(useBg, true);
    });
    setContext('ly-table-thead-col-colors', colors);
</script>

<td
    class="px-4 py-2
          text-left align-top
          font-normal">
    {@render children?.()}
</td>
